import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ComponentEnTranslation from './components/__i18n__/en';
import ComponentFrTranslation from './components/__i18n__/fr';
import { initReactI18next } from 'react-i18next';
import familiplusPage_FR from './pages/familiplus/__i18n__/fr';
import familiplusPage_EN from './pages/familiplus/__i18n__/en';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    // debug: true,
    resources: {
      en: {
        component: ComponentEnTranslation,
        familiplusPage: familiplusPage_EN,
      },
      fr: {
        component: ComponentFrTranslation,
        familiplusPage: familiplusPage_FR,
      },
    },
    supportedLngs: ['fr', 'en'],
    fallbackLng: ['fr', 'en'],
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      // order and from where user language should be detected
      order: ['path', 'localStorage', 'navigator'],
      // keys or params to lookup language from
      lookupLocalStorage: 'i18nextLng',
      // cache user language on
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
      excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    },
  });

export default i18n;
